import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
export class NirunStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      nirunLastSyncTime: {},
    });
  }

  async getLastSyncTime(tenantIds = null) {
    // this.loading = true;
    let queryOption = {};
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    try {
      const res = await rp
        .get(`${config.api.url}/${config.api.version}/3rd/system/nirun/last/sync`, {
          qs: queryOption,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const data = res.body || {};
        this.nirunLastSyncTime = data.since;
        return data;
      }
    } catch (err) {
      throw err;
    } finally {
      // this.loading = false;
    }
  }

  async syncPatient(tenantIds) {
    this.loading = true;
    try {
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/3rd/system/nirun/import/all`, {
          body: {
            tenantIds,
          },
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const data = res.body || {};
        console.log(data);
        this.nirunLastSyncTime = data.since;
        return data;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createVitalSignForNirun(data) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/3rd/system/nirun/vitalsign`;
      const res = await rp
        .post(url, {
          body: data,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
    } finally {
      this.loading = false;
    }
  }
}

export default new NirunStore();
